import { forwardRef } from 'react'
import type { ComponentPropsWithoutRef, ReactNode } from 'react'
import styles from './HeaderIconButton.module.css'

type HeaderIconButtonProps = ComponentPropsWithoutRef<'button'> & {
  icon: ReactNode
  'aria-label': string
}

/**
 * The header's round icon button, darker on hover or while its menu is open.
 * Forwards its ref and props so it can be a dropdown's trigger.
 */
export const HeaderIconButton = forwardRef<
  HTMLButtonElement,
  HeaderIconButtonProps
>(({ icon, className, ...props }, ref) => (
  <button
    ref={ref}
    type='button'
    className={`${styles.button} ${className ?? ''}`}
    {...props}
  >
    {icon}
  </button>
))

HeaderIconButton.displayName = 'HeaderIconButton'
